import axios from "axios";
import useUserStore from '../store/useUserStore';

export const api = axios.create({
    baseURL: "https://api.modernwash.co.kr/api/v1",
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  });

export const bannerApi = axios.create({
  baseURL: "https://api.modernwash.co.kr/api/v1/banners",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export const memberApi = axios.create({
  baseURL: "https://api.modernwash.co.kr/api/v1/member",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export const subApi = axios.create({
  baseURL: "https://api.modernwash.co.kr/api/v1/subscriptions",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// 모든 요청에 Authorization 헤더 자동 추가
api.interceptors.request.use(
  (config) => {
    const token = useUserStore.getState().userToken;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

bannerApi.interceptors.request.use(
  (config) => {
    const token = useUserStore.getState().userToken;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

memberApi.interceptors.request.use(
  (config) => {
    const token = useUserStore.getState().userToken;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

subApi.interceptors.request.use(
  (config) => {
    const token = useUserStore.getState().userToken;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터 - 토큰 만료 시 자동 로그아웃 처리
const setupResponseInterceptor = (apiInstance) => {
  apiInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // 토큰이 만료되었거나 유효하지 않음
        const { clearToken } = useUserStore.getState();
        clearToken();
        
        // 로그인 페이지로 리다이렉트
        if (typeof window !== 'undefined') {
          alert('토큰이 만료되었습니다. 다시 로그인해주세요.');
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );
};

// 모든 API 인스턴스에 응답 인터셉터 적용
setupResponseInterceptor(api);
setupResponseInterceptor(bannerApi);
setupResponseInterceptor(memberApi);
setupResponseInterceptor(subApi);
